// 관리자 회원관리 + 통계 API 래퍼.

import type {
  AdminBulkGrantCouponInput,
  AdminGrantCouponInput,
  AdminOrderDto,
  AdminStatsDto,
  AdminUserDto,
} from "@oo/shared";
import { api } from "@/api/client.ts";

// 회원 검색 목록. q 가 비면 전체.
export async function listMembers(q: string): Promise<AdminUserDto[]> {
  const qs = q.trim() ? `?q=${encodeURIComponent(q.trim())}` : "";
  const data = await api.get<{ users: AdminUserDto[] }>(`/admin/users${qs}`);
  return data.users;
}

// 회원 단건 상세.
export async function getMember(id: string): Promise<AdminUserDto> {
  const data = await api.get<{ user: AdminUserDto }>(`/admin/users/${id}`);
  return data.user;
}

// 적립금 조정. 반환: 실제 적용액 + 갱신된 회원.
export async function adjustPoints(
  id: string,
  amount: number,
  reason: string,
): Promise<{ applied: number; user: AdminUserDto }> {
  return api.post<{ applied: number; user: AdminUserDto }>(`/admin/users/${id}/points`, {
    amount,
    reason,
  });
}

// 회원에게 쿠폰 수동 지급.
export async function grantCoupon(id: string, input: AdminGrantCouponInput): Promise<void> {
  await api.post(`/admin/users/${id}/coupons`, input);
}

// 전체 회원에게 일괄 쿠폰 지급. 반환: 대상 회원 수 + 발급 장수.
export async function grantCouponToAll(
  input: AdminBulkGrantCouponInput,
): Promise<{ users: number; granted: number }> {
  return api.post<{ users: number; granted: number }>("/admin/users/coupons/bulk", input);
}

// 특정 회원의 주문 내역 (최신순).
export async function listMemberOrders(id: string): Promise<AdminOrderDto[]> {
  const data = await api.get<{ orders: AdminOrderDto[] }>(`/admin/users/${id}/orders`);
  return data.orders;
}

// 회원 이용제한 설정/해제.
export async function setRestricted(id: string, restricted: boolean): Promise<AdminUserDto> {
  const data = await api.post<{ user: AdminUserDto }>(`/admin/users/${id}/restrict`, { restricted });
  return data.user;
}

// 대시보드 통계 조회.
export async function getStats(): Promise<AdminStatsDto> {
  const data = await api.get<{ stats: AdminStatsDto }>("/admin/stats");
  return data.stats;
}
